/**
 * 路由 base 路径 - 服务端和前端共用
 * 修改此值时需同步更新 server/index.mjs
 */
export const ROUTER_BASE_PATH = '/fly'

/**
 * 必火推广相关链接常量
 */

// PC端 - 创作中心必火推广页面
export const FLY_PC_URL =
  'https://member.bilibili.com/platform/growingUp/fly?from=fly_landing'

// H5端 - 必火推广页面
export const FLY_H5_URL =
  'https://cm.bilibili.com/fly-h5?navhide=1#/fly/home?from=fly_landing'

// cm.bilibili.com 主站
export const CM_URL = 'https://cm.bilibili.com'

/**
 * B站商业平台相关链接
 */

// 品牌银行
export const BRAND_BANK_URL = 'https://e.bilibili.com/site/'

// 三连广告平台
export const SANLIAN_URL = 'https://ad.bilibili.com'

// 花火平台
export const HUAHUO_URL = 'https://huahuo.bilibili.com/'

// 代理商平台
export const AGENT_URL = 'https://cm.bilibili.com/agent'
